import { PublicPage } from ".";
import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "../../constants";
import { WrapperLess } from "../generic";

interface OwnProps {
}

interface OwnState {
}

export class SignInPage extends React.Component<OwnProps, OwnState> {
    public render() {
        return <WrapperLess>
            <PublicPage additionalClasses="signin" wrapperId="wrapper">
                <div id="page">
                    <div id="logo">
                        <Link to={Paths.Home}>
                            <img src={process.env.PUBLIC_URL + "/content/images/logo.png"} />
                        </Link>
                    </div>

                    {this.props.children}
                </div>
            </PublicPage>
            <div id="credit" key={4}><a href="https://www.webitects.com">Designed and built in Chicago by <strong>Webitects</strong></a></div>
        </WrapperLess>;
    }
}



// WEBPACK FOOTER //
// ./src/components/page/SignInPage.tsx